import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white py-20" aria-labelledby="faq-title" data-id="element-48" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-49" data-mp="1ccdnwo55bito">
        <SectionHeading id="faq-title" data-id="element-50" data-mp="2a2icelvuq6qz">Frequently Asked <span className="text-aqua" data-id="element-51" data-mp="2a05x6ghhaahm">Questions</span></SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-52" data-mp="254gu43692bgk">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-lg border bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-gold shadow-sm' : 'border-gray-200'}`} data-id="element-53" data-mp="1v4zqrseh09nr" data-mpi={index}>
                <h3 className="font-sans" data-id="element-54" data-mp="omjcmb0h62bj">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-semibold text-navy transition-colors duration-150 ease-out hover:bg-pearl focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-aqua/30 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-55" data-mp="jorjxes0ac6a">
                    <span data-id="element-56" data-mp="1fonf820mzjwk">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-aqua transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-57" data-mp="1fnc8puft3y1r" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-58" data-mp="16pa0attqu34g">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-59" data-mp="rzudtq18wjuk">
                      <p className="border-t border-gray-200 px-5 py-4 leading-relaxed text-gray-600 sm:px-6" data-id="element-60" data-mp="2pn583d5nlahk">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}